export default __webpack_public_path__ + "static/media/manual-btn.7a436e30.png";